import { render, staticRenderFns } from "./Comments.vue?vue&type=template&id=ef59c75e&scoped=true"
import script from "./Comments.vue?vue&type=script&lang=js"
export * from "./Comments.vue?vue&type=script&lang=js"
import style0 from "./Comments.vue?vue&type=style&index=0&id=ef59c75e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef59c75e",
  null
  
)

export default component.exports